<script>
    import {createEventDispatcher, onMount} from 'svelte';
    import {Link} from 'svelte-routing';
    import {store} from './../stores.js';
    import {list} from './../config.js';

    const dispatch = createEventDispatcher();

    const user = store('credential', 'getAuth');

    export let allow_leave = true;

    const handler_leave = (e) => {
        if (!allow_leave) {
            let popup = new bootstrap.Modal(document.getElementById('leave-locker'), {backdrop: 'static'});
                popup.show();

            dispatch('lock', {state: true});
        }
    };

    let title;

    onMount(() => {
        title = list.find((el) => decodeURI(location.pathname).replace('/calc/', '') === el.link).title ?? '';
    });
</script>

<div class="card-header">
    {#if title}
        <div class="dropdown">
            <button class="btn btn-link dropdown-toggle p-0" type="button" id="switcher" data-bs-toggle="dropdown" on:click={handler_leave}>
                {title}
            </button>
            <ul class="dropdown-switcher dropdown-menu z9999" aria-labelledby="switcher">
                {#each list as item}
                    {#if
                        (
                            $user && $user.calcs && $user.calcs.includes(item.calc)
                        ) && (
                            typeof item.hide === 'undefined' ||
                            item.hide === false
                        )
                    }
                        <li><Link to="/calc/{ item.link }" class="dropdown-item">{ item.title }</Link></li>
                    {/if}
                {/each}
            </ul>
        </div>
    {/if}
</div>
